import { render, staticRenderFns } from "./ScanningMessageModal.vue?vue&type=template&id=287c23a4&scoped=true&"
import script from "./ScanningMessageModal.vue?vue&type=script&lang=js&"
export * from "./ScanningMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c23a4",
  null
  
)

export default component.exports